import actions from './actions';

const initState = {
  total: 0,
  limit: 50,
  skip: 0,
  profiles: [],
  error: '',
  loading: false,
};

export default function guestCustomProfileReducer(state = initState, action) {
  switch (action.type) {
    case actions.LOAD_CUSTOM_PROFILE:
      return {
        ...state,
        error: '',
        loading: true,
      };
    case actions.LOAD_CUSTOM_PROFILE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case actions.LOAD_CUSTOM_PROFILE_SUCCESS: {
      // const { profiles } = state;
      const { data, meta } = action;
      // console.log('newProfiles', newProfiles);
      return {
        ...state,
        total: meta.total,
        limit: meta.limit,
        skip: meta.skip,
        profiles: data,
        loading: false,
        error: '',
      };
    }
    default:
      return state;
  }
}
